import axios from "axios";
import url from "../config/urlServiceConfig";

const weightAPI = {
  getAll: () => axios.get(`${url.weight}`),
  update: (body) => axios.put(url.weight, body),
};

export default weightAPI;
